import React from "react";

function DownloadPage() {
  return (
    <>
      <div className=" min-h-screen flex flex-col items-center mt-40">
        <h1 className="text-3xl font-bold mb-28">How to Get Started</h1>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 px-4">
          <div className="bg-gray-300 rounded-lg p-8 text-center shadow-md">
            <h2 className="text-xl font-bold mb-4">Step 1</h2>
            <p className="mb-4">Download the Chrome extension using the link below.</p>
            <a
              href="https://example.com/download"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-6 py-2 bg-gray-800 text-white rounded hover:bg-gray-700"
            >
              Download
            </a>
          </div>
          <div className="bg-gray-300 rounded-lg p-8 text-center shadow-md">
            <h2 className="text-xl font-bold mb-4">Step 2</h2>
            <p>Open the Chrome extension and sign in to your account.</p>
          </div>
          <div className="bg-gray-300 rounded-lg p-8 text-center shadow-md">
            <h2 className="text-xl font-bold mb-4">Step 3</h2>
            <p>
              Select the cart you want to use. When ready, click "Add to Cart" to
              start shopping.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default DownloadPage;